import { render } from "./UserVerification.vue?vue&type=template&id=e9ce809e&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"

import "./UserVerification.vue?vue&type=style&index=0&id=e9ce809e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_nnqy633ba33w3ap4lrqhdb3em4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ce809e"]])

export default __exports__